/**
 * 構造化データ（result_data）から検索用テキストを生成する
 * Functions側のgenerateSearchTextFromStructuredDataと同じロジック
 *
 * @param resultData - 構造化されたresult_data
 * @returns 検索用テキスト（スペース区切り）
 */
export const generateSearchTextFromResultData = (resultData: Record<string, unknown>): string => {
  const textValues: string[] = [];

  /**
   * オブジェクトを再帰的に走査し、valueプロパティの値を抽出する
   */
  const extractValues = (obj: unknown): void => {
    if (obj === null || obj === undefined) return;

    if (Array.isArray(obj)) {
      obj.forEach(item => extractValues(item));
    } else if (typeof obj === 'object') {
      const record = obj as Record<string, unknown>;

      if ('value' in record) {
        const value = record.value;
        if (typeof value === 'string' && value.trim()) {
          textValues.push(value.trim());
        } else if (typeof value === 'number') {
          textValues.push(String(value));
        }
      }

      Object.entries(record).forEach(([key, value]) => {
        if (key !== 'value' && key !== 'bounding_boxes' && key !== 'page' && key !== 'id') {
          extractValues(value);
        }
      });
    }
  };

  extractValues(resultData);

  return textValues.join(' ');
};
